import { useSuspenseQuery } from '@tanstack/react-query';
import { SourcingService } from 'api-clients/monolith';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useNavigationPaths } from '@/hooks/use-navigation-paths';
import { queryKeys } from '@/query-keys';

import { Card } from './card';

interface AutomationsRecommendationProps {
  onCountChange: (count: number) => void;
}

export function AutomationsRecommendation({
  onCountChange,
}: AutomationsRecommendationProps) {
  const navigate = useNavigate();
  const { sourceSettingsPath } = useNavigationPaths();

  const {
    data: { automation_enabled: automationEnabled },
  } = useSuspenseQuery({
    queryKey: [...queryKeys.dashboard.recommendations.automation],
    queryFn: () =>
      SourcingService.getInternalApiSourcingDashboardAutomationRecommendation(),
  });

  const hasRecommendation = !automationEnabled;

  useEffect(() => {
    onCountChange(hasRecommendation ? 1 : 0);
  }, [hasRecommendation, onCountChange]);

  if (!hasRecommendation) return null;

  return (
    <Card
      recommendationType="automation"
      onClick={() => navigate(sourceSettingsPath)}
      value={0}
    />
  );
}
